import keys from '@debbie/common/dist/cache/keys.js';
import { TemplateType, } from '@debbie/common/dist/templates/index.js';
import { useMutation } from '@debbie/common/dist/util/hooks.js';
import { objectBy } from '@debbie/common/dist/util/index.js';
import * as templatesAPI from '@debbie/cortex/dist/api/templates.js';
import { selectExclusiveContent } from '@debbie/cortex/dist/exclusiveContent/selectors.js';
import { c, h } from '@debbie/cortex/dist/index.js';
import { useMe } from '@debbie/cortex/dist/me/index.js';
import q from '@debbie/cortex/dist/query.js';
import { templatesEntity, useTemplates, } from '@debbie/cortex/dist/templates/index.js';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { styled } from 'styled-components';
import THEME from '../../theme.js';
import { errorNotification } from '../../utils/errors.js';
import AddItem from '../Icons/AddItem.js';
import { PlusSquare } from '../Icons/index.js';
import { Badge, Button, Input, Modal, Panel, PlaceholderLoader, Select, Timestamp, } from '../index.js';
import PowerTable, { FilterType } from '../PowerTable.js';
import { Tab, TabList, TabPanel, Tabs } from '../Tabs.js';
const Templates = () => {
    const templatesLoadable = useTemplates();
    const templatesRaw = h.hasData(templatesLoadable)
        ? templatesLoadable.data
        : null;
    const templates = templatesRaw
        ? Object.values(templatesRaw.reduce((acc, t) => {
            acc[t.templateId] = t;
            return acc;
        }, {}))
        : [];
    const meLoadable = useMe();
    const me = h.hasData(meLoadable) ? meLoadable.data : null;
    const lang = useSelector((s) => s.lang);
    const [state, setState] = useState({
        toggleNewTemplateModal: false,
        template: {
            name: '',
            type: TemplateType.EMAIL,
        },
    });
    const createTemplateMutation = useMutation(async () => {
        const templateId = await templatesAPI
            .create({
            ...state.template,
            details: state.template.type === TemplateType.AUTOCALL
                ? { actions: [] }
                : {},
        })
            .then((res) => res.id);
        c.redirect.redirect(`/settings/template-editor/${templateId}`);
        q.invalidate(keys.write.create(templatesEntity));
        setState({
            ...state,
            toggleNewTemplateModal: false,
        });
    }, {
        onError: (err) => {
            errorNotification(lang, err, 'create', lang.errorEntities.template);
        },
    });
    const publicTemplates = templates.filter((t) => t.public);
    const tenantTemplates = templates.filter((t) => !t.public);
    return (React.createElement("div", null,
        React.createElement(Tabs, { defaultIndex: 0 },
            React.createElement(TabList, null,
                React.createElement(Tab, null,
                    lang.templates.customTemplates,
                    ' ',
                    React.createElement(Badge, { theme: THEME.COLOR_ACCENT }, tenantTemplates.length)),
                React.createElement(Tab, null,
                    lang.templates.standardTemplates,
                    ' ',
                    React.createElement(Badge, { theme: THEME.COLOR_GREY }, publicTemplates.length)),
                me && (React.createElement(Button, { onClick: () => {
                        setState({
                            ...state,
                            toggleNewTemplateModal: !state.toggleNewTemplateModal,
                        });
                    }, size: "small", style: { float: 'right' } },
                    lang.templates.newTemplate,
                    ' ',
                    React.createElement(PlusSquare, { style: {
                            margin: '0.1em 0 -0.1em',
                        } })))),
            React.createElement(TabPanel, null, templatesRaw && tenantTemplates ? (tenantTemplates.length === 0 ? (React.createElement(AddItem, { style: {
                    height: '200px',
                    margin: '150px auto 0px auto',
                    display: 'block',
                } })) : (React.createElement(TemplateList, { templates: tenantTemplates }))) : (React.createElement(PlaceholderLoader, null))),
            React.createElement(TabPanel, null, templatesRaw && publicTemplates ? (React.createElement(TemplateList, { templates: publicTemplates })) : (React.createElement(PlaceholderLoader, null)))),
        state.toggleNewTemplateModal && (React.createElement(Modal, { onToggle: () => {
                setState({
                    ...state,
                    toggleNewTemplateModal: !state.toggleNewTemplateModal,
                });
            }, header: lang.templates.newTemplate },
            React.createElement(Select, { onChange: (e) => {
                    setState({
                        ...state,
                        template: {
                            ...state.template,
                            type: e.target.value,
                        },
                    });
                }, value: state.template.type },
                React.createElement("option", { value: "" }, lang.templates.selectType),
                React.createElement("option", { value: TemplateType.EMAIL }, "Email"),
                React.createElement("option", { value: TemplateType.LETTER }, lang.templates.letter),
                React.createElement("option", { value: TemplateType.SMS }, "Sms"),
                React.createElement("option", { value: TemplateType.AUTOCALL }, "Autocall"),
                React.createElement("option", { value: TemplateType.EBOKS }, "e-Boks"),
                React.createElement("option", { value: TemplateType.CREDITOR_MESSAGE }, lang.templateTypes[TemplateType.CREDITOR_MESSAGE]),
                React.createElement("option", { value: TemplateType.DEBTOR_MESSAGE }, lang.templateTypes[TemplateType.DEBTOR_MESSAGE]),
                React.createElement("option", { value: TemplateType.NOTE }, lang.templateTypes[TemplateType.NOTE])),
            React.createElement(Input, { placeholder: lang.templates.name, value: state.template.name, onChange: (e) => {
                    setState({
                        ...state,
                        template: {
                            ...state.template,
                            name: e.target.value,
                        },
                    });
                } }),
            React.createElement(Button, { loading: createTemplateMutation.isLoading, onClick: () => createTemplateMutation.mutate(), disabled: !(state.template.name && state.template.type), block: true }, lang.templates.create)))));
};
export default Templates;
const TemplateList = (props) => {
    const lang = useSelector((s) => s.lang);
    const meLoadable = useMe();
    const me = h.hasData(meLoadable) ? meLoadable.data : null;
    const exclusiveContent = useSelector(selectExclusiveContent);
    const { templates } = props;
    return (React.createElement(Panel, { noBodyPadding: true }, React.createElement(PowerTable, { data: templates, genKey: (template) => template.templateId, onClick: (template) => {
            c.redirect.redirect(`/settings/template-editor/${template.templateId}`);
        }, pagination: {
            type: 'none',
            pageSize: templates.length,
        }, values: {
            name: {
                label: 'Skabelon',
                width: '60%',
                toCmp: (templateId) => templateId,
                map: (name) => {
                    return (React.createElement("div", { style: {
                            whiteSpace: 'nowrap',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                        } },
                        React.createElement("b", null, name)));
                },
            },
            createdAt: {
                label: 'Oprettet',
                map: (date) => React.createElement(Timestamp, { date: date }),
                align: 'right',
                filter: {
                    type: FilterType.DateRange,
                },
            },
            type: {
                label: 'Type',
                map: (type) => React.createElement(Type, { type: type }),
                align: 'right',
                filter: {
                    type: FilterType.Category,
                    categories: objectBy(Object.values(TemplateType).map((type) => ({
                        type,
                        label: lang.templateTypes[type],
                    })), (o) => o.type),
                },
            },
        }, defaultSortKey: "name", defaultSortDirection: "ASC", searchable: true, toSearchStr: (t) => `${t.name}` })));
};
export const StateStyled = styled.div `
  background-color: ${(props) => THEME.STATE_COLORS[props.state]};
  margin-bottom: 8px;
  color: ${THEME.COLOR_SECONDARY};
  padding: 0.2em 1.1em;
  border-radius: 0.8em;
  font-size: 0.8em;
  font-weight: bold;
  display: inline-block;
`;
export const TypeStyled = styled.div `
  background-color: ${(props) => THEME.TYPE_COLORS[props.type]};
  color: ${THEME.COLOR_SECONDARY};
  padding: 0.2em 1.1em;
  border-radius: 0.8em;
  font-size: 0.6em;
  vertical-align: middle;
  font-weight: bold;
  display: inline-block;
`;
const Type = (props) => {
    const lang = useSelector((s) => s.lang);
    return (React.createElement(TypeStyled, { type: props.type }, lang.templateTypes[props.type]));
};
//# sourceMappingURL=Templates.js.map